import CommonCss from "nlib/common/common.module.scss";

import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { checkIsBusinessUser } from "selectors/user";
import { getCurrentXeroOrganizationId, getSelectedBusinessData } from "selectors/businesses";
import { useSelector } from "react-redux";
import AutoTooltip from "nlib/ui/AutoTooltip";
import Constants from "const/Constants";
import DataStatuses from "const/DataStatuses";
import React, { useMemo } from "react";

const { EMPTY_PLACEHOLDER } = Constants;

const AddressCell = ({ documentData }) => {
  const { vendorId, paymentType, status, address } = documentData;

  const { name: addressName } = address || {};

  const { settings: { allowClientPayeeSelection } = {} } = useSelector(getSelectedBusinessData);

  const xeroBusiness = !!useSelector(getCurrentXeroOrganizationId);

  const content = (xeroBusiness || paymentType) && addressName;

  const exportedStatus = status === DataStatuses.EXPORTED;

  const businessUser = useSelector(checkIsBusinessUser);

  const icon = useMemo(() => {
    if (addressName) {
      if ((!businessUser || allowClientPayeeSelection) && !exportedStatus) {
        if (vendorId) {
          return <Icons.User className={CommonCss.positiveText} />;
        }

        return <Icons.UserPlus className={CommonCss.highlightText} />;
      }

      return <Icons.User />;
    }

    return null;
  }, [exportedStatus, businessUser, allowClientPayeeSelection, vendorId, addressName]);

  return (
    <AutoTooltip
      active={!!content}>
      <span className={Css.icon}>{icon}</span>
      <span>
        {content || EMPTY_PLACEHOLDER}
      </span>
    </AutoTooltip>
  );
};

export default React.memo(AddressCell);
